"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _B2PY6EORcjs = require('../__chunks/B2PY6EOR.cjs');
require('../__chunks/FHIGX2EE.cjs');
require('../__chunks/NSONUP5C.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-field.tsx
var TagName = "input";
var useFormField = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormField2(props) {
    return _B2PY6EORcjs.useFormControl.call(void 0, props);
  }
);
var FormField = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function FormField2(props) {
    const htmlProps = useFormField(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.FormField = FormField; exports.useFormField = useFormField;
